import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '@shared/configs/config';
import { parseApiDate } from '@shared/helpers/date-format.helper';

@Pipe({ name: 'rangeFormatV2', pure: true })
export class RangeFormatV2Pipe implements PipeTransform {
  transform(start: string, end: string, isFullDay: boolean = false, onlyTime: boolean = false, onlyDate = false): string {
    const _start = parseApiDate(start);
    const _end = parseApiDate(end);

    const startDate = _start ? _start.format(Config.DATE_FORMAT_DOTS) : '';
    const endDate = _end ? _end.format(Config.DATE_FORMAT_DOTS) : '';

    const startTime = _start ? _start.format(Config.TIME) : '';
    const endTime = _end ? _end.format(Config.TIME) : '';

    const sameDates = startDate === endDate;

    if (onlyTime) {
      return `${startTime} - ${endTime}`;
    }

    if (isFullDay || onlyDate) {
      return sameDates ? `${startDate}` : `${startDate} - ${endDate}`;
    }

    return sameDates
      ? `${startDate} ${startTime} - ${endTime}`
      : `${startDate} ${startTime} - ${endDate} ${endTime}`;
  }
}
